import { useState } from "react";
import { Check, Loader2, ArrowUpRight } from "lucide-react";
import { Card, Badge } from "@/components/kit";

const ORDER = ["starter", "pro", "multi"];

// Annual prices (lookup keys starter_annual / pro_annual / multi_annual at
// NZ$79/159/399 per month billed yearly) are live in Stripe.
const ANNUAL_ENABLED = true;

export default function Tiers({ sub, subscribing, onSubscribe }) {
  const [annual, setAnnual] = useState(false);
  const showToggle = ANNUAL_ENABLED;

  return (
    <div>
      {showToggle && (
        <div className="flex justify-center mb-6">
          <div className="inline-flex items-center bg-zinc-100 p-1.5 rounded-full border border-zinc-200">
            <button
              onClick={() => setAnnual(false)}
              className={`px-4 py-1.5 text-xs font-semibold rounded-full transition-all duration-200 ${!annual ? "bg-white text-zinc-900 shadow-sm" : "text-zinc-500 hover:text-zinc-800"}`}
            >
              Monthly
            </button>
            <button
              onClick={() => setAnnual(true)}
              className={`flex items-center gap-1.5 px-4 py-1.5 text-xs font-semibold rounded-full transition-all duration-200 ${annual ? "bg-zinc-900 text-white shadow-sm" : "text-zinc-500 hover:text-zinc-800"}`}
            >
              Annual
              <span className="bg-emerald-500 text-zinc-950 text-[10px] font-bold px-2 py-0.5 rounded-full">Save 20%</span>
            </button>
          </div>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {ORDER.map((key) => {
          const t = sub.tiers[key];
          const current = sub.current === key;
          const price = showToggle && annual ? t.annual_price : t.price;
          const lookupKey = showToggle && annual ? (t.annual_lookup_key || t.lookup_key) : t.lookup_key;
          return (
            <Card key={key} className={`p-6 flex flex-col ${current ? "border-zinc-900 ring-1 ring-zinc-900" : ""}`} testid={`tier-${key}`}>
              <div className="flex items-center justify-between">
                <div className="font-display font-medium">{t.name}</div>
                {current && <Badge level="success">Current</Badge>}
              </div>
              <div className="mt-2 font-display text-3xl font-semibold tnum">
                NZ${price}
                <span className="text-sm text-zinc-400 font-normal">/mo</span>
              </div>
              {showToggle && annual && (
                <div className="text-xs text-zinc-400 mt-0.5">Billed annually (NZ${price * 12}/yr)</div>
              )}
              <div className="mt-1.5 w-fit text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full px-2.5 py-0.5">
                14-day free trial
                {sub.trial_days_left != null && ` — ${sub.trial_days_left} days left`}
              </div>
              <ul className="mt-4 space-y-2 text-sm text-zinc-600 flex-1">
                {t.features.map((ff) => (
                  <li key={ff} className="flex items-center gap-2">
                    <Check className="h-3.5 w-3.5 text-emerald-600" /> {ff}
                  </li>
                ))}
              </ul>
              <button
                data-testid={`subscribe-${key}`}
                disabled={current || !!subscribing}
                onClick={() => onSubscribe(lookupKey, key)}
                className={`mt-6 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors duration-200 ${
                  current
                    ? "bg-zinc-100 text-zinc-400 cursor-default"
                    : "bg-zinc-900 text-white hover:bg-zinc-800"
                }`}
              >
                {subscribing === key ? (
                  <Loader2 className="h-4 w-4 animate-spin" />
                ) : current ? (
                  "Current plan"
                ) : (
                  <>Start free trial <ArrowUpRight className="h-4 w-4" /></>
                )}
              </button>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
